module.exports = __webpack_public_path__ + "static/pic01@1x-34ecc7d5e46695f1d41fb0ecc5ec0947.jpg";